import { render, staticRenderFns } from "./ReportAffDetail.vue?vue&type=template&id=76c87542&scoped=true"
import script from "./ReportAffDetail.vue?vue&type=script&lang=js"
export * from "./ReportAffDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportAffDetail.vue?vue&type=style&index=0&id=76c87542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c87542",
  null
  
)

export default component.exports